import React from 'react';
import DineOpsOutletSetupScreen from './DineOpsOutletSetupScreen';

/*
 * SETUP-002..005: the four Outlet Setup masters as their own sidebar entries
 * (2026-10-08). Each is the same screen fixed to one tab, so the grid, the form
 * and the department close / fallback actions stay in one place. The role's
 * actions for the entry (allowedActions from main_layout) pass straight through.
 */
type Props = { allowedActions?: string[] };
export const DineOpsDepartmentsScreen: React.FC<Props> = ({ allowedActions = [] }) => <DineOpsOutletSetupScreen only="stations" allowedActions={allowedActions} />;
export const DineOpsTablesScreen: React.FC<Props> = ({ allowedActions = [] }) => <DineOpsOutletSetupScreen only="tables" allowedActions={allowedActions} />;
export const DineOpsSectionsScreen: React.FC<Props> = ({ allowedActions = [] }) => <DineOpsOutletSetupScreen only="sections" allowedActions={allowedActions} />;
export const DineOpsQuickNotesScreen: React.FC<Props> = ({ allowedActions = [] }) => <DineOpsOutletSetupScreen only="notes" allowedActions={allowedActions} />;
